<template>
  <div class="userinfo-teacher">
    <div class="content-title">个人信息</div>
    <div class="content-line"></div>
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="50px"
      class="content-form"
      label-position="top"
    >
      <el-form-item>
        <el-col :span="11">
          <el-form-item label="姓名:" prop="teacherName">
            <el-input
              v-model="ruleForm.teacherName"
              placeholder="请输入真实姓名"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="2">&nbsp;</el-col>
        <el-col :span="11">
          <el-form-item label="工号:" prop="teacherNumber">
            <el-input
              v-model="ruleForm.teacherNumber"
              placeholder="请输入工作编号"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-form-item>
      <el-form-item>
        <el-col :span="11">
          <el-form-item label="手机:" prop="phone">
            <el-input
              v-model="phone"
              placeholder=""
              disabled
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="2">&nbsp;</el-col>
        <el-col :span="11">
          <el-form-item label="入职时间">
            <el-form-item prop="entryDate">
              <el-date-picker
                type="date"
                placeholder="请选择入职时间"
                v-model="ruleForm.entryDate"
                value-format="yyyy-MM-dd"
                style="width: 100%"
              ></el-date-picker>
            </el-form-item>
          </el-form-item>
        </el-col>
      </el-form-item>
      <el-form-item label="个人简介" prop="resume">
        <el-input
          type="textarea"
          :autosize="{ minRows: 2, maxRows: 4 }"
          v-model="ruleForm.resume"
          :maxlength="maxlength"
          show-word-limit
        ></el-input>
      </el-form-item>
    </el-form>
    <div class="content-line"></div>
    <div class="content-invite">
      邀请码<el-input v-model="inviteCode"></el-input>
    </div>
    <!-- <div class="next-btn" @click="submitForm('ruleForm')">下一步</div> -->
    <div class="next-btn" @click="submitForm('ruleForm')">完成</div>
  </div>
</template>

<script>
export default {
  name: "",
  data() {
    return {
      phone: '',
      ruleForm: {
        teacherName: "",
        teacherNumber: "",
        entryDate: "",
        resume: "",
      },

      rules: {
        teacherName: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        teacherNumber: [
          { required: true, message: "请输入工作编号", trigger: "change" },
        ],
        // entryDate: [
        //   {
        //     required: true,
        //     message: "请选择入职时间",
        //     trigger: "change",
        //   },
        // ],
      },
      maxlength: 100, // textarea字数
      // inviteCode: "bAalnCLfEB", // 邀请码
      inviteCode: "", // 邀请码
    };
  },
  created() {
    this.phone = this.user.phone;
    this.ruleForm.teacherName = this.user.teacherName
    this.ruleForm.teacherNumber = this.user.teacherNumber
    this.ruleForm.entryDate = this.user.entryDate
    this.ruleForm.resume = this.user.resume
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.inviteCode.trim() == "") {
            return this.$message("请先填写邀请码");
          }
          // console.log("验证成功,下一步");
          // console.log(this.ruleForm)
          // console.log(this.inviteCode)
          this.$emit("getSchoolInfo", {
            teacherInfo: this.ruleForm,
            inviteCode: this.inviteCode,
          });
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped >
@import "userinfo-teacher.scss";
</style>